import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@pnl/ui';
import { router } from './router';
import { queryClient } from './lib/queryClient';

export default function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="pnl_trader_theme">
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
